<template>
  <div>

    <div class="container-fluid bg-white py-3">
      <div class="row">
        <div class="col-12">
          <h1 class="mb-0">Add a Customer</h1>
        </div>
      </div>
    </div>


    <div class="container-fluid">
     <div class="row mk-businessdocumentation pt-3 mt-4">
        <div class="col-12 col-md-6 bg-white mx-auto pt-5 pb-3 d-flex justify-content-between align-items-center">
          <h2>Documentation</h2>
          <p class="mb-0">Step 3</p>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6 bg-white mx-auto py-3">
          <hr />
        </div>
      </div>


      <div class="row">
        <div class="col-12 col-md-6 mx-auto bg-white py-3">
          <div class="form-group row">

            <label for="privacy_documenets" class="col-md-3 col-form-label">Privacy Documents</label>
            <div class="col-md-9">

              <form
                enctype="multipart/form-data"
                novalidate
                v-if="isInitial || isSaving || privacy_documents.length === 0"
              >

                <div class="dropbox d-flex justify-content-center align-items-center">
                  <input
                    type="file"
                    multiple
                    :name="uploadFieldName"
                    :disabled="isSaving"
                    @change="privacyFilesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
                    accept=".doc,.docx,.pdf,.xls,.xlsx,.csv,.txt,.rft,.jpg,.jpeg,.png"
                    class="input-file"
                  />

                  <p class="text-grey font-14 mb-0 d-flex justify-content-center p-0" v-if="isInitial || privacy_documents.length === 0">
                    Drag your file(s) here to begin
                    <br />or click to browse
                  </p>

                  <p v-if="isSaving">Uploading {{ fileCount }} files...</p>
                </div>

              </form>


              <!-- SUCCESS / uploaded file card -->
              <div v-if="isSuccess">
                <div class="row filelist justify-content-between">
                  <div
                    class="col-md-4 my-2"
                    v-for="(item, index) in privacy_documents"
                    :key="index"
                  >
                    <div class="bg-lightblue d-flex align-items-center justify-content-between p-2">
                      <p class="borders mb-0">{{item.originalName}}</p>
                      <span @click="onRemovePrivacyFile(item)" class="has-interaction p-1">
                        <i class="fas fa-times-circle fa-lg"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!--FAILED-->
              <div v-if="isFailed">
                <h2>Uploaded failed.</h2>
                <p>
                  <a href="javascript:void(0)" @click="resetPrivacyDocuments()">Try again</a>
                </p>
                <pre>{{ uploadError }}</pre>
              </div>

            </div>


            <div class="col-12 mx-auto py-3">
              <hr />
            </div>


            <div class="col-12 d-flex justify-content-between align-items-center">
              <el-button
                class="btn-light-blue"
                @click="onPrevious"
                plain
              >Back</el-button>

              <div>
                <el-button
                  class="btn-light-blue"
                  @click="onSubmitDraft"
                  plain
                >Save as Draft</el-button>

                <el-button
                  class="btn-blue"
                  @click="onSubmit"
                  type="primary"
                >Save and Submit</el-button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>


  </div>
</template>





<script>
import { upload } from "./uploadfaker";
import Business from "../../../models/Business";

const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3;
export default {
  props: {
    initial_business: {
      type: Business
    }
  },
  computed: {
    isInitial() {
      return this.privacyCurrentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.privacyCurrentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.privacyCurrentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.privacyCurrentStatus === STATUS_FAILED;
    },
  },
  mounted() {
    this.resetPrivacyDocuments();
  },
  data() {
    return {
      //
      privacy_documents: [],
      uploadError: null,
      privacyCurrentStatus: null,
      financeCurrentStatus: null,
      uploadedFiles: [],
      business: this.initial_business,
      formData: new FormData(),
      privacyCurrentStatus: null,
      uploadFieldName: "privacy_documents[]"
    };
  },
  methods: {
    resetPrivacyDocuments() {
      // reset form to initial state
      this.privacyCurrentStatus = this.privacy_documents.length
        ? STATUS_SUCCESS
        : STATUS_INITIAL;
      this.uploadError = null;
    },
    savePrivacyDocuments(formData, fieldName) {
      // upload data to the server
      this.privacyCurrentStatus = STATUS_SAVING;
      upload(formData, fieldName)
        .then(x => {
          this.privacy_documents = [].concat(x);
          this.privacyCurrentStatus = STATUS_SUCCESS;
        })
        .catch(err => {
          this.uploadError = err.response;
          this.privacyCurrentStatus = STATUS_FAILED;
        });
    },
    privacyFilesChange(fieldName, fileList) {
      // handle file changes
      const formData = new FormData();
      if (!fileList.length) return;
      // append the files to FormData
      Array.from(Array(fileList.length).keys()).map(x => {
        formData.append(fieldName, fileList[x], fileList[x].name);
        this.formData.append(fieldName, fileList[x], fileList[x].name);
      });
      // save it
      this.savePrivacyDocuments(formData, fieldName);
    },
    onRemovePrivacyFile(file) {
      let index = this.privacy_documents.indexOf(file);
      this.privacy_documents.splice(index, 1);
      this.$message({
        type: "success",
        message: "File Removed"
      });
    },
    financeFilesChange(fieldName, fileList) {
      // handle file changes
      const formData = new FormData();
      if (!fileList.length) return;
      // append the files to FormData
      Array.from(Array(fileList.length).keys()).map(x => {
        formData.append(fieldName, fileList[x], fileList[x].name);
        this.formData.append(fieldName, fileList[x], fileList[x].name);
      });

      // save it
      this.saveFinanceDocuments(formData);
    },
    onSubmitDraft() {
      this.business.media = this.formData;

      this.$emit("draft", this.business);
    },
    onSubmit() {
      this.business.media = this.formData;
      this.$emit("submit", this.business);
    },
    onPrevious() {
      this.business.media = this.formData;

      this.$emit("previous", this.business);
    }
  }
};
</script>


<style lang="scss">
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
}
.filelist {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  color: dimgray;
  padding: 10px 10px;
  position: relative;
}
.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}

.sec-order-form {
  h1 {
    color: white !important;
  }

  .white-text-table {
    color: #fff;
  }
}
</style>